<template>
  <div id="testTemplate">
    <b-modal
      v-model="localValue"
      id="modalTest"
      size="lg"
      centered
      cancel-disabled
      no-close-on-esc
      no-close-on-backdrop
      hide-header-close
      hide-footer
      :title="$t('dialog-title-videoTest')"
    >
      <div v-if="modalStep === 0">
        <div class="mx-auto" style="width: 96px;">
          <img width="96px" height="96px" alt="Test" src="/static-appopensalud/img/icons/test-icon.svg" />
        </div>
        <div v-if="inputSmallToken" class="col text-center pt-1">
          <p style="text-align: center">{{ $t('needValidTokenVideoTest') }}</p>
          <b-form-input  v-bind:readonly="waitingSessionCheck" id="token-input" v-model="smallToken" :placeholder="$t('introduce-token')"></b-form-input>
        </div>
        <br/>
        <div class="col text-center">
          <p>{{ $t('dialog-title-presentation') }}</p>
          <b-button
            center
            v-on:click="stepOne"
            v-if="!waitingSessionCheck"
            align-h="center"
            variant="outline-primary"
          ><b-icon icon="play" aria-hidden="true"></b-icon> {{ $t('dialog-title-pressToInitVideoTest') }}</b-button>
          <b-button
            center
            disabled
            v-on:click="stepOne"
            v-if="waitingSessionCheck"
            align-h="center"
            variant="outline-primary"
          ><b-spinner small label="Spinning"></b-spinner> {{ $t('dialog-title-waitingSession') }}</b-button>
        </div>
      </div>
      <transition name="fade">
        <div v-if="modalStep === -1" style="min-height:360px;">
          <div class="mx-auto" style="width: 96px;margin: 20px 0 40px 0;">
            <img width="96px" height="96px" alt="danger" src="/static-appopensalud/img/icons/danger-icon.svg" />
          </div>
          <div v-if="otLoggingError">
            <p class="text-danger text-center">
              <b>{{ $t('video-test.adblock-error') }}</b>
            </p>
          </div>
          <div v-else>
            <p class="text-danger text-center">
              <b>{{ $t('dialog-title-minimumRequisitesVideoTest') }}</b>
            </p>
            <br />
            <p class="text-danger errorPanel">
              <small>
                {{ $t('test-requisites') }}
              </small>
            </p>
          </div>
          <div class="col text-center mt-2">
            <b-button center v-on:click="retryTest" align-h="center" variant="outline-danger">
              <b-icon icon="arrow-counterclockwise" aria-hidden="true"></b-icon> {{ $t('retry-init') }}
            </b-button>
          </div>
        </div>
        <div v-if="modalStep === 1" style="min-height:360px;">
          <b-tabs v-model="tabActive" content-class="mt-3 p-0">
            <b-tab v-bind:disabled="tabActive !== 0" class="p-0">
              <template v-slot:title >
                {{ $t('dialog_title_tabOneVideoTest') }}
              </template>
              <p
                class="p-2 text-justify"
                v-if="(videoGranted==null && audioGranted==null) || (videoGranted && audioGranted)"
              >
                <small>{{ $t('dialog-text1-tab1-VdeoTest') }}</small>
              </p>
              <p
                class="p-2 text-danger text-center"
                v-if="(videoGranted!=null && audioGranted!=null) && (!videoGranted && !audioGranted)"
              >
                <small>
                  <b>{{ $t('dialog-text2-tab1-VideoTest') }}</b>
                </small>
              </p>
              <b-container fluid="md" class="text-center">
                <b-row justified>
                  <b-col cols="6">
                    <b-img
                      v-if="videoGranted"
                      align-h="center"
                      src="/static-appopensalud/img/icons/webcam-white.svg"
                      class="p-4"
                      width="96px"
                      v-bind:class="{ bgPermission: videoGranted, bgNoPermission: !videoGranted }"
                      rounded="circle"
                    ></b-img>
                    <b-img
                      v-if="!videoGranted"
                      align-h="center"
                      src="/static-appopensalud/img/icons/webcam-slash-white.svg"
                      class="p-4"
                      width="96px"
                      v-bind:class="{ bgPermission: videoGranted, bgNoPermission: !videoGranted }"
                      rounded="circle"
                    ></b-img>
                    <p>
                      <small>{{ $t('camera') }}</small>
                    </p>
                  </b-col>
                  <b-col cols="6">
                    <b-img
                      v-if="audioGranted"
                      src="/static-appopensalud/img/icons/microphone-white.svg"
                      class="p-4"
                      width="96px"
                      v-bind:class="{ bgPermission: audioGranted, bgNoPermission: !audioGranted }"
                      rounded="circle"
                    ></b-img>
                    <b-img
                      v-if="!audioGranted"
                      src="/static-appopensalud/img/icons/microphone-slash-white.svg"
                      class="p-4"
                      width="96px"
                      v-bind:class="{ bgPermission: audioGranted, bgNoPermission: !audioGranted }"
                      rounded="circle"
                    ></b-img>
                    <p>
                      <small>{{ $t('microphone') }}</small>
                    </p>
                  </b-col>
                </b-row>
              </b-container>
              <br />
              <div class="col text-center">
                <div class="footerLine mb-3"></div>
                <b-button
                  v-on:click="checkPermissions"
                  v-if="!reAskpermission && !stepOnePassed && tabActive === 0 && !waitingDevices"
                  center
                  align-h="center"
                  variant="outline-primary"
                ><b-icon icon="chat-square-dots" aria-hidden="true"></b-icon> {{ $t('request-permissions') }}</b-button>
                <b-button
                  v-on:click="retryTest"
                  v-if="reAskpermission && !stepOnePassed && tabActive === 0 && !waitingDevices"
                  center
                  align-h="center"
                  variant="outline-danger"
                >
                  <b-icon icon="arrow-counterclockwise" aria-hidden="true"></b-icon> {{ $t('retry-init') }}
                </b-button>
                <b-button
                  v-on:click="stepTwo"
                  v-if="stepOnePassed && tabActive === 0 && !waitingDevices"
                  center
                  align-h="center"
                  variant="outline-primary"
                >
                  <b-icon icon="arrow-right" aria-hidden="true"></b-icon> {{ $t('next-label') }}
                </b-button>
                <b-button
                  center
                  disabled
                  v-on:click="stepTwo"
                  v-if="stepOnePassed && tabActive === 0 && waitingDevices"
                  align-h="center"
                  variant="outline-primary"
                ><b-spinner small label="Spinning"></b-spinner> {{ $t('checkingDevices') }}</b-button>
              </div>
            </b-tab>
            <b-tab v-bind:disabled="tabActive !== 1" class="p-0">
              <template v-slot:title>
                {{ $t('devices') }}
              </template>
              <p>
                <small> {{ $t('test-center-image-and-audio') }}</small>
              </p>
              <b-container class="bv-example-row">
                <b-row>
                  <b-col md="3" sm="12">
                    <video class="device-center" id="localVideo" autoplay playsinline />
                  </b-col>
                  <b-col md="9" sm="12" class="pl-4">
                    <p style="margin-top: 0"> {{ $t('video-device') }} </p>
                    <b-form-input readonly v-bind:placeholder="webcamString"></b-form-input>
                  </b-col>
                </b-row>
                <hr/>
                <b-row align-h="center">
                  <b-col md="3" sm="12">
                    <div class="device-center text-center">
                    <b-img
                      src="/static-appopensalud/img/icons/microphone-blue.svg"
                      width="20px"
                    ></b-img>
                    <div style="margin-top: 15px;">
                      <meter high="0.25" max="1" value="0"></meter>
                      </div>
                      </div>
                  </b-col>
                  <b-col md="9" sm="12" class="pl-4">
                  <p style="margin-top: 0"> {{ $t('audio-device') }} </p>
                  <b-form-input readonly v-bind:placeholder="microString"></b-form-input>
                  </b-col>
                </b-row>
              </b-container>
              <br/>
              <div class="col text-center">
                <div class="footerLine mb-3"></div>
                <b-button v-on:click="stepThree" center align-h="center" variant="outline-primary">
                  <b-icon icon="arrow-right" aria-hidden="true"></b-icon> {{ $t('next-label') }}
                </b-button>
              </div>
            </b-tab>
            <b-tab v-bind:disabled="tabActive !== 2" class="p-0">
              <template v-slot:title>
                {{ $t('network') }}
              </template>
              <b>{{ $t('dialog-title-speedTest') }}</b>
              <b-container class="text-center">
                <b-row justified  class="px-0">
                  <b-col md="6" sm="12" class="px0 speed-box-border">
                    <highcharts :options="videoOptions" ref="highchartVideo"></highcharts>
                  </b-col>
                  <b-col md="6" sm="12" class="px0">
                    <highcharts :options="audioOptions" ref="highchartsAudio"></highcharts>
                  </b-col>
                </b-row>
              </b-container>
              <br />
              <div v-if="!waitingTestDone">
                <b>{{ $t('dialog-title-overalRatingVideoTest') }}</b>
                <div>
                  <RatingCustom v-bind:title="$t('video-quality')" v-bind:rating="resultTestValues.videoQualityValue"></RatingCustom>
                  <RatingCustom v-bind:title="$t('audio-quality')" v-bind:rating="resultTestValues.audioQualityValue"></RatingCustom>
                </div>
                <b>{{ $t('dialog-title-resultVideoTest') }}</b>
                <div class="text-center" v-if="resultTest">
                  <b-icon font-scale="3" variant="primary" icon="check2-circle" aria-hidden="true"></b-icon><br/>
                  <h6 class="text-center text-primary"> {{ $t('title-result-test-ok') }} </h6>
                </div>
                <div class="text-center" v-if="!resultTest">
                  <b-icon font-scale="3" variant="danger" icon="x-circle" aria-hidden="true"></b-icon>
                  <h5 class="text-center text-danger">{{ $t('tittle-resulta-test-ko') }} </h5>
                  <p> {{ $t('subtitle-result-test-ko') }} </p>
                </div>
              </div>
              <br/>
              <div class="col text-center">
                <div class="footerLine mb-3"></div>
                  <b-button
                    v-on:click="retryTest"
                    v-if="!waitingTestDone"
                    center
                    align-h="center"
                    class="m-1"
                    variant="outline-danger">
                    <b-icon icon="arrow-counterclockwise" aria-hidden="true"></b-icon> {{ $t('retry-init') }}
                  </b-button>
                  <b-button
                    center
                    v-on:click="stepRedirectSession"
                    v-if="!waitingTestDone"
                    align-h="center"
                    variant="outline-primary"
                    class="m-1"
                  > {{ successText }}</b-button>
                  <b-button
                    center
                    disabled
                    v-on:click="stepOne"
                    v-if="waitingTestDone"
                    align-h="center"
                    variant="outline-primary"
                    class="m-1"
                  ><b-spinner small label="Spinning"></b-spinner> {{ $t('dialog-button-waitingTest') }}</b-button>
              </div>
            </b-tab>
          </b-tabs>
        </div>
      </transition>
    </b-modal>
  </div>
</template>

<script>
import OT from '@opentok/client'
import ClientJS from 'clientjs'
import NetworkTest from 'opentok-network-test-js'
import { BIcon, BIconCheck2Circle, BIconXCircle, BIconArrowRight, BIconArrowCounterclockwise, BIconChatSquareDots, BIconPlay, BModal, BTab, BRow, BCol, BButton, BSpinner, BContainer, BTabs, BImg, BFormInput } from 'bootstrap-vue'
import RatingCustom from '@/components/utils/RatingCustom.vue'
import { Chart } from 'highcharts-vue'
import { detectAnyAdblocker } from 'vue-adblock-detector'

var VideoOptions = {
  title: {
    text: 'Video',
    class: 'col-lg-3',
    style: {
      fontSize: '12',
      width: '30%'
    }
  },
  credits: false,
  plotOptions: {
    series: {
      lineWidth: 1,
      marker: {
        enabled: false
      }
    }
  },
  yAxis: {
    floor: 0,
    // ceiling: 2400,
    title: {
      text: 'bitrate'
    }
    /* plotLines: [
      {
        value: 250,
        color: 'red',
        dashStyle: 'shortdash',
        width: 1
      }
    ] */
  },
  chart: {
    // width: 120,
    height: 150,
    type: 'spline',
    renderTo: 'video-meter',
    styledMode: true
  },
  legend: {
    enabled: false
  },
  tooltip: {
    enabled: false
  },
  series: [
    {
      data: [0]
    }
  ]
}
var AudioOptions = {
  title: {
    text: 'Audio',
    style: {
      fontSize: '12'
    }
  },
  credits: false,
  plotOptions: {
    series: {
      lineWidth: 1,
      marker: {
        enabled: false
      }
    }
  },
  yAxis: {
    floor: 0,
    // ceiling: 2400,
    title: {
      text: 'bitrate'
    }
    /* plotLines: [
      {
        value: 250,
        color: 'red',
        dashStyle: 'shortdash',
        width: 1
      }
    ] */
  },
  chart: {
    // width: 120,
    height: 150,
    type: 'spline',
    renderTo: 'video-meter',
    styledMode: true
  },
  legend: {
    enabled: false
  },
  tooltip: {
    enabled: false
  },
  series: [
    {
      data: [0]
    }
  ]
}
export default {
  name: 'Test',
  components: {
    RatingCustom,
    BIcon,
    BIconCheck2Circle,
    BIconXCircle,
    BIconArrowRight,
    BIconArrowCounterclockwise,
    BIconChatSquareDots,
    BIconPlay,
    highcharts: Chart,
    BModal,
    BTab,
    BContainer,
    BRow,
    BCol,
    BButton,
    BSpinner,
    BTabs,
    BImg,
    BFormInput
  },
  props: {
    value: {
      type: Boolean,
			default: null
    },
    fromAppointmentRequest: Boolean
  },
  data () {
    return {
      waitingSessionCheck: false,
      inputSmallToken: false,
      smallToken: null,
      showOverlay: false,
      volume: 0,
      context: null,
      script: null,
      instant: 0,
      audioGranted: null,
      videoGranted: null,
      reAskpermission: false,
      waitingDevices: false,
      waitingTestDone: true,
      webcamString: '',
      microString: '',
      tabActive: 0, // 0: Permissions, 1: Devices, 2: Network
      modalStep: 0, // -1: Error page, 0: Session init, 1: Tabs
      stepOnePassed: false,
      stepTwoPassed: false,
      stepThreePassed: false,
      mediaStream: null,
      modalShow: true,
      imgWebcamGranted: 'webcam-white.svg',
      imgWebcamNoGranted: 'microphone-slash-white.svg',
      imgMicrophoneGranted: 'microphone-white.svg',
      imgMicrophoneNoGranted: 'microphone-slash-white.svg',
      videoOptions: VideoOptions,
      audioOptions: AudioOptions,
      publisherEl: '',
      subscriberEl: '',
      session: {},
      publisher: {},
      subscriber: {},
      resultTestVisible: true,
      resultTest: false,
      opentok: {
        apiKey: '',
        sessionId: '',
        token: ''
      },
      resultTestValues: {
        AspnetUserId: '',
        IdVideoSession: '',
        webCamPresent: false,
        microphonePresent: false,
        os: '',
        osVersion: '',
        browser: '',
        browserVersion: '',
        userAgent: '',
        timeZone: '',
        videoBitRate: 0,
        audioBitRate: 0,
        videoQualityValue: 0,
        videoQualityText: 'No definido',
        audioQualityValue: 0,
        audioQualityText: 'No definido',
        testResult: false,
        ip: '',
        error: ''
      },
      otLoggingError: false
    }
  },
  created () {
    if (this.fromAppointmentRequest) {
      this.inputSmallToken = false
      this.smallToken = null
    } else if (!this.$route.params.token) {
      this.inputSmallToken = true
      this.smallToken = ''
    } else {
      this.smallToken = this.$route.params.token
      detectAnyAdblocker().then((detected) => {
        if (detected) {
          this.modalStep = -1
          this.otLoggingError = true
        }
      })
    }
  },
  computed: {
    localValue: {
      get () {
        return this.value !== null ? this.value : true
      },
      set (value) {
        this.$emit('input', value)
      }
    },
    successText () {
      return this.fromAppointmentRequest ? this.$t('continue') : this.$t('dialog-button-go-to-session')
    }
  },
  methods: {
    initBasicRequisites: function () {
      const _this = this
      this.waitingDevices = true
      const otNetworkTest = new NetworkTest(OT, {
        apiKey: this.opentok.apiKey,
        sessionId: this.opentok.sessionId,
        token: this.opentok.token
      })
      otNetworkTest
        .testConnectivity()
        .then((results) => {
          if (!results.success) {
            if (results.failedTests && results.failedTests[0] && results.failedTests[0].error && results.failedTests[0].error.name === 'LoggingServerConnectionError') {
              this.otLoggingError = true
            }
            _this.modalStep = -1
            if (results.failedTests[0]) {
              _this.resultTestValues.error = `${results.failedTests[0].error.name} ${results.failedTests[0].error.message}`
            } else {
              _this.resultTestValues.error = 'Opentok conectivityTest error'
            }
            _this.sendResultTest()
            _this.modalStep = -1
            _this.waitingDevices = false
          } else {
            _this.modalStep = 1
            _this.tabActive = 1
            _this.createMirror()
            _this.waitingDevices = false
          }
        })
        .catch(function (error) {
          _this.resultTestValues.error = `${error.name} ${error.message}`
          _this.sendResultTest()
          _this.modalStep = -1
          _this.waitingDevices = false
        })
    },
    initPrecall: function () {
      const otNetworkTest = new NetworkTest(OT, {
        apiKey: this.opentok.apiKey,
        sessionId: this.opentok.sessionId,
        token: this.opentok.token
      })
      let audioBytesReceivedAdded = this.audioOptions.series[0].data[0]
      let videoBytesReceivedAdded = this.videoOptions.series[0].data[0]
      otNetworkTest.testQuality((stats) => {
        if (stats.video !== 'undefined') {
          let currentVideoBytes = stats.video.bytesReceived - videoBytesReceivedAdded
          videoBytesReceivedAdded = stats.video.bytesReceived
          this.videoOptions.series[0].data.push(currentVideoBytes / 10)
        }
        if (stats.audio !== 'undefined') {
          let currentAudioBytes = stats.audio.bytesReceived - audioBytesReceivedAdded
          audioBytesReceivedAdded = stats.audio.bytesReceived
          this.audioOptions.series[0].data.push(currentAudioBytes / 10)
        }
      })
        .then((results) => {
        // This function is called when the quality test is completed.
				this.resultTestVisible = true
          if (results.audio.supported === true && results.video.supported === true) {
            this.resultTest = true
            this.resultTestValues.testResult = true
            this.resultTestValues.webCamPresent = true
            this.resultTestValues.microphonePresent = true
            this.$store.commit('video/setResultVideoTest', true)
          }
          this.resultTestValues.videoBitRate = parseFloat((Math.round(results.video.bitrate * 100) / 100).toFixed(2))
          this.resultTestValues.videoQualityValue = parseFloat((Math.round(results.video.mos * 100) / 100).toFixed(1))
          this.resultTestValues.videoQualityText = this.getMosQuality(results.video.mos)
          this.resultTestValues.audioBitRate = parseFloat((Math.round(results.audio.bitrate * 100) / 100).toFixed(2))
          this.resultTestValues.audioQualityValue = parseFloat((Math.round(results.audio.mos * 100) / 100).toFixed(1))
          this.resultTestValues.audioQualityText = this.getMosQuality(results.audio.mos)
          let publisherSettings = {}
          if (results.video.reason) {
            publisherSettings.videoSource = null // audio-only
          } else {
            publisherSettings.frameRate =
              results.video.recommendedFrameRate
            publisherSettings.resolution =
              results.video.recommendedResolution
          }
          if (!results.audio.supported) {
            publisherSettings.audioSource = null
            // video-only, but you probably don't want this -- notify the user?
          }
          if (
            !publisherSettings.videoSource &&
            !publisherSettings.audioSource
          ) {
            // Do not publish. Notify the user.
          } else {
            // Publish to the "real" session, using the publisherSettings object.
          }
          this.sendResultTest()
          this.waitingTestDone = false
        })
        .catch((error) => {
          this.resultTestValues.error = `${error.name} ${error.message}`
          this.sendResultTest()
          this.modalStep = -1
          this.waitingTestDone = false
          this.$emit('error')
        })
    },
    getMosQuality: function (mosValue) {
      if (mosValue < 1.69) {
        return this.$i18n.t('test-result.Bad')
      } else if (mosValue >= 1.7 && mosValue <= 2.39) {
        return this.$i18n.t('test-result.Poor')
      } else if (mosValue >= 2.4 && mosValue <= 3.09) {
        return this.$i18n.t('test-result.Fair')
      } else if (mosValue >= 3.1 && mosValue <= 3.79) {
        return this.$i18n.t('test-result.Good')
      } else if (mosValue >= 3.8 && mosValue <= 4.5) {
        return this.$i18n.t('test-result.Excellent')
      }
    },
    sendResultTest: function () {
      this.resultTestValues.videoSessionUserToken = this.smallToken
      this.$api.post('webapp/VideoTestSessionController', this.resultTestValues)
    },
    fillUserData: function () {
      let c = new ClientJS()
      this.resultTestValues.os = c.getOS().name
      this.resultTestValues.osVersion = c.getOS().version
      this.resultTestValues.browser = c.getBrowser().name
      this.resultTestValues.browserVersion = c.getBrowser().version
      this.resultTestValues.userAgent = navigator.userAgent
      this.resultTestValues.timeZone = new Date().getTimezoneOffset()
      this.resultTestValues.ip = window.location.host
    },
    stepThree: function () {
      this.tabActive = 2
      this.stepThreePassed = true
      this.stopWebRTCMirror()
      this.initPrecall()
    },
    stopWebRTCMirror: function () {
      const videoElem = document.querySelector('video')
      const stream = videoElem.srcObject
      const tracks = stream.getTracks()
      tracks.forEach(function (track) {
        track.stop()
      })
      videoElem.srcObject = null
    },
    stepTwo: function () {
      this.initBasicRequisites()
    },
    createMirror: function () {
      this.tabActive = 1
      // Set video canvas
      const video = document.querySelector('video')
      const videoTracks = this.mediaStream.getVideoTracks()
      const audioTracks = this.mediaStream.getAudioTracks()
      if (videoTracks != null) {
        this.webcamString = videoTracks[0].label
      }
      if (audioTracks != null) {
        this.microString = audioTracks[0].label
      }
      window.stream = this.mediaStream
      video.srcObject = this.mediaStream
      // Set audio gauge
      this.volumeMeter()
      // Show button
      this.stepTwoPassed = true
    },
    stepOne: function () {
      const _this = this
      if (!this.fromAppointmentRequest && !this.smallToken) {
        this.goToErrorView('SESSION_INVALID', 'Need a valid token to start video test', 3)
      } else {
        this.waitingSessionCheck = true
        this.$api
          .get(`webapp/VideoTestSessionController${this.smallToken ? `?smallToken=${this.smallToken}` : ''}`)
          .then(async function (response) {
            _this.opentok.apiKey = response.data.data.opentokKey
            _this.opentok.sessionId = response.data.data.opentokSession
            _this.opentok.token = response.data.data.opentokPublishToken
            _this.resultTestValues.AspnetUserId = response.data.data.aspnetUsersId
            _this.resultTestValues.IdVideoSession = response.data.data.idVideoSession
            _this.$root.$emit('bv::show::modal', 'modal-1', '#btnShow')
            _this.fillUserData()
            _this.tabActive = 0
            _this.showOverlay = true
            _this.modalStep = 1
            _this.waitingSessionCheck = false
          })
          .catch(function (error) {
            _this.waitingSessionCheck = false
            _this.goToErrorView('SESSION_INVALID', error.message, 1)
          })
      }
    },
    connectToSource: function (stream, callback) {
      try {
        this.mic = this.context.createMediaStreamSource(stream)
        this.mic.connect(this.script)
        // necessary to make sample run, but should not be.
        this.script.connect(this.context.destination)
        if (typeof callback !== 'undefined') {
          callback(null)
        }
      } catch (e) {
        console.error(e)
        if (typeof callback !== 'undefined') {
          callback(e)
        }
      }
    },
    stepRedirectSession: function () {
      if (this.fromAppointmentRequest) {
        this.$emit('resultTest', this.resultTest)
      } else {
        this.$router.push({ name: 'VideoToken', params: { token: this.smallToken } })
      }
    },
    resetData: function () {
      this.videoOptions = VideoOptions
      this.audioOptions = AudioOptions
      this.reAskpermission = false
      this.stepOnePassed = false
      this.tabActive = 0
      this.stepThreePassed = false
      this.waitingTestDone = true
    },
    retryTest: function () {
      this.resetData()
      if (this.fromAppointmentRequest) {
        this.stepOne()
      } else {
        location.reload()
      }
    },
    updateMeter: function (pct) {
      // var meter = document.getElementById('meter');
      // meter.style.width = pct + '%';
      this.volume = pct
    },
    volumeMeter: function () {
      const _this = this
      const instantMeter = document.querySelector('meter')
      // const instantValueDisplay = document.querySelector('#instant .value')
      window.AudioContext = window.AudioContext || window.webkitAudioContext
      navigator.getUserMedia =
        navigator.getUserMedia ||
        navigator.webkitGetUserMedia ||
        navigator.mozGetUserMedia
      let audioContext = new AudioContext()
      let mediaStreamSource = audioContext.createMediaStreamSource(
        this.mediaStream
      )
      let processor = audioContext.createScriptProcessor(2048, 1, 1)
      mediaStreamSource.connect(audioContext.destination)
      mediaStreamSource.connect(processor)
      processor.connect(audioContext.destination)
      processor.onaudioprocess = function (e) {
        let inputData = e.inputBuffer.getChannelData(0)
        let inputDataLength = inputData.length
        let total = 0
        for (let i = 0; i < inputDataLength; i++) {
          total += Math.abs(inputData[i++])
        }
        let rms = Math.sqrt(total / inputDataLength)
        instantMeter.value = rms.toFixed(2) * 10
        // instantValueDisplay.innerText =
        _this.volume = rms * 100
      }
    },
    audioGain: function () {
      let audioContext = new AudioContext()
      let source = audioContext.createMediaStreamSource(this.mediaStream)
      let volume = audioContext.createGain()
      source.connect(volume)
      volume.connect(audioContext.destination)
      setInterval(() => {
        this.volume = volume
      }, 200)
    },
    checkPermissions: function (event) {
      const _this = this
      try {
        navigator.permissions
          .query({ name: 'microphone' })
          .then((permissionObj) => {
            permissionObj.state === 'granted'
              ? (_this.audioGranted = 1)
              : (_this.audioGranted = 0)
            navigator.permissions
              .query({ name: 'camera' })
              .then((permissionObj) => {
                permissionObj.state === 'granted'
                  ? (_this.videoGranted = 1)
                  : (_this.videoGranted = 0)
                _this.requestPermission(event)
              })
          })
          .catch(() => {
            _this.requestPermission(event)
          })
      } catch (ex) {
        _this.requestPermission(event)
      }
    },
    requestPermission: function () {
      const _this = this
      try {
        navigator.mediaDevices
          .getUserMedia({ audio: true, video: true })
          .then(function (MediaStream) {
            _this.mediaStream = MediaStream
            if (MediaStream.getVideoTracks().length > 0) {
              _this.videoGranted = 1
            } else {
              _this.videoGranted = 0
            }
            if (MediaStream.getAudioTracks().length > 0) {
              _this.audioGranted = 1
            } else {
              _this.audioGranted = 0
            }
            if (_this.videoGranted === 1 && _this.audioGranted === 1) {
              _this.stepOnePassed = true
            } else {
              _this.stepOnePassed = false
            }
            // e.target.disabled = true
          })
          .catch(function () {
            _this.videoGranted = 0
            _this.audioGranted = 0
            _this.reAskpermission = true
          })
      } catch (ex) {
        console.log(`Test error: ${ex}`)
      }
    },
    goToErrorView (errorTitle, errorMsg, errorCode) {
      if (this.fromAppointmentRequest) {
        this.$emit('resultTest', false)
      } else {
        this.$store.commit('video/setError', errorCode)
        this.$router.push({name: 'Error', params: { lang: this.$i18n.locale }, query: { error_title: errorTitle, error_msg: errorMsg, token: this.$store.state.video.smallToken }})
      }
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
@import '../../../static-appopensalud/css/vendor/custom_highcharts.scss';
#modalTest{
  #localVideo {
    border-radius: 15px;
  }

  .modal-dialog {
    max-width: 600px;
    max-height: 620px;
  } 

  h1,
  h2 {
    font-weight: normal;
  }

  ul {
    list-style-type: none;
    padding: 0;
  }

  li {
    display: inline-block;
    margin: 0 10px;
  }

  a {
    color: #35495e;
  }

  .fade-enter-active,
  .fade-leave-active {
    transition: opacity 0.5s;
  }

  .fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
    opacity: 0;
  }

  video {
    max-width: 100%;
    border: 1px solid gray;
    background-color: lightgray;
  }
  div#meters > div {
    margin: 0 0 1em 0;
  }

  div#meters div.label {
    display: inline-block;
    font-weight: 400;
    margin: 0 0.5em 0 0;
    width: 3.5em;
  }

  div#meters div.value {
    display: inline-block;
  }

  meter {
    width: 100%;
  }

  meter#clip {
    color: red;
  }

  meter#slow {
    color: #888888;
  }

  meter#instant {
    color: #007bff;
  }

  .bgPermission {
    background-color: lightgreen;
  }

  .bgNoPermission {
    background-color: lightcoral;
  }

  .footerLine {
    border-top: 1px solid #dee2e6;
  }

  .errorPanel {
    padding: 15px;
    border: 1px solid red;
    background-color: #ff00000a;
  }

  .infoPanel {
    background-color: #d0d0d0;
    border: 1px solid #9b9b9b;
    padding: 10px;
    font-size: 12px;
  }
  #token-input {
    margin: 0 auto;
    width: 221px;
  }

  .nav-link {
    font-size: 15px;
  }

  .crop {
    width:275px;
    overflow:hidden;
    height:50px;
    line-height:50px;
  }
  .device-center{
    margin-left: auto;
    margin-right: auto;
  }
  .border-light-gray {
    border-color: lightgray !important;
  }

  @media screen and (max-width: 480px) {
      .nav {
          padding-left:2px;
          padding-right:2px;
      }
      .nav li {
          display:block !important;
          width:100%;
          margin:0px;
          text-align: justify !important;
      }
      .nav li.active {
          border-bottom:1px solid #ddd!important;
          margin: 0px;
      }

      .speed-box-border {
          border-bottom:1px solid lightgrey !important;
      }
  }
  @media screen and (min-width: 481px) {
        .speed-box-border {
          border-right:1px solid lightgrey !important;
      }

  }
}
</style>



// WEBPACK FOOTER //
// src/components/video-launcher/Test.vue